import { Box, styled } from "@mui/material"
import { TimePill } from "components/TimePill"
import moment from "moment-timezone"
import React from "react"

interface TimesPickerProps {
  availableTimes: moment.Moment[]
  selected: null | moment.Moment
  onSelect: (newSelectedTime: moment.Moment) => void
  Title: React.ReactNode
}

export const TimePicker = (props: TimesPickerProps) => {
  const { availableTimes, selected, onSelect, Title } = props
  return (
    <_RootContainer>
      {Title}
      <_ContentContainer role="radiogroup">
        {availableTimes.map((time) => {
          const onChange = () => onSelect(time)
          return (
            <TimePill
              key={time.valueOf()}
              date={time}
              onChange={onChange}
              isChecked={time.isSame(selected)}
            />
          )
        })}
      </_ContentContainer>
    </_RootContainer>
  )
}

// LAYOUT

const _RootContainer = styled(Box)({
  display: "flex",
  flexFlow: "column nowrap",
  alignItems: "stretch",

  paddingBottom: "30px",

  overflow: "hidden",
})

const _ContentContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, 90px)",
  gridGap: 5,
  alignContent: "flex-start",
  justifyContent: "flex-start",

  maxHeight: 155,
  padding: 20,
  borderRadius: 10,

  backgroundColor: theme.palette.primary.lightest,

  overflowY: "auto",
  "&::-webkit-scrollbar": {
    display: "none",
  },
})) as typeof Box
